import React, { useState, useEffect } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminStudentAdd = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    program_id: '',
    student_type: '', // ✅ New field added
    address: '',
    fees: '',
  });

  const [programs, setPrograms] = useState([]);

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI('get', 'admin/programs', '');
  }, []);

  useEffect(() => {
    if (responce && Array.isArray(responce.data)) {
      setPrograms(responce.data);
    }
  }, [responce]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    callAPI('post', 'admin/add-student-admission', form);
    console.log('Form submitted:', form);
    
  };
   useEffect(() => {
        if (responce?.data && statusCode === 201) {
          toast.success("Student Register Successfully!");
          setTimeout(() => {
            navigate(uiRoutes.admin.student.list);
          }, 1000);
        }
      }, [responce, statusCode, navigate]);
      
 const filteredPrograms = programs.filter((p) => p.type === form.student_type);
  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container card mt-4 p-4">
          <h4 className="mb-3">Add Student</h4>
          <form onSubmit={handleSubmit}>
            {/* Row 1 */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label>First Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                />
                   <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.first_name}
                  </span>
              </div>
              <div className="col-md-6 mb-3">
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={form.last_name}
                  onChange={handleChange}
                />
                   <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.last_name}
                  </span>
              </div>
            </div>

            {/* Row 2 */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />
                   <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.email}
                  </span>
              </div>
              <div className="col-md-6 mb-3">
                <label>Mobile No</label>
                <input
                  type="text"
                  className="form-control"
                  name="mobile_no"
                  value={form.mobile_no}
                  onChange={handleChange}
                />
                   <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.mobile_no}
                  </span>
              </div>
            </div>

            {/* Row 3 */}
           <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label>Student Type</label>
                <select
                  className="form-control"
                  name="student_type"
                  value={form.student_type}
                  onChange={handleChange}
                >
                  <option value="">Select Type</option>
                  <option value="kids">Kids</option>
                  <option value="student">Student</option>
                </select>
                <span className="val-message">{error?.data?.student_type}</span>
              </div>

              <div className="col-md-6 mb-3">
                <label>Program</label>
                <select
                  className="form-control"
                  name="program_id"
                  value={form.program_id}
                  onChange={handleChange}
                  disabled={!form.student_type}
                >
                  <option value="">Select Program</option>
                  {filteredPrograms.map((prog) => (
                    <option key={prog.id} value={prog.id}>
                      {prog.name}
                    </option>
                  ))}
                </select>
                {form.program_id && (
                  <div className="text-muted mt-1">
                    Program Type: <strong>{filteredPrograms.find(p => String(p.id) === form.program_id)?.type}</strong>
                  </div>
                )}
                <span className="val-message">{error?.data?.program_id}</span>
              </div>
            </div>

            {/* Row 4 */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label>Fees</label>
                <input
                  type="number"
                  className="form-control"
                  name="fees"
                  value={form.fees}
                  onChange={handleChange}
                />
                 <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.fees}
                  </span>
              </div>
              <div className="col-md-6 mb-3">
                <label>Address</label>
                <textarea
                  className="form-control"
                  name="address"
                  rows="2"
                  value={form.address}
                  onChange={handleChange}
                ></textarea>
                 <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.address
                    }
                  </span>
              </div>
            </div>

            <div className="text-end">
              <button type="submit" className="btn btn-primary">Submit</button>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default AdminStudentAdd;

// import React, { useState, useEffect } from 'react';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// import { uiRoutes } from '../../../../routes/ui/uiRoutes';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';

// const AdminStudentAdd = () => {
//   const navigate = useNavigate();

//   const initialForm = {
//     first_name: '',
//     last_name: '',
//     email: '',
//     mobile_no: '',
//     program_id: '',
//     student_type: '', // selected first
//     address: '',
//     fees: '',
//   };

//   const [form, setForm] = useState(initialForm);
//   const [programs, setPrograms] = useState([]);
//   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

//   useEffect(() => {
//     callAPI('get', 'admin/programs', '');
//   }, []);

//   useEffect(() => {
//     if (responce && Array.isArray(responce.data)) {
//       setPrograms(responce.data);
//     }
//   }, [responce]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // Reset program selection if student type changes
//     if (name === 'student_type') {
//       setForm({
//         ...form,
//         student_type: value,
//         program_id: '', // clear program selection
//       });
//     } else {
//       setForm({ ...form, [name]: value });
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Basic validation
//     if (!form.first_name || !form.email || !form.mobile_no || !form.student_type || !form.program_id) {
//       toast.error('Please fill all required fields.');
//       return;
//     }

//     const selectedProgram = programs.find((p) => String(p.id) === form.program_id);
//     if (selectedProgram?.type !== form.student_type) {
//       toast.error("Selected program doesn't match the student type.");
//       return;
//     }

//     const sanitizedForm = {
//       ...form,
//       fees: form.fees ? Number(form.fees) : 0,
//     };

//     callAPI('post', 'admin/add-student-admission', sanitizedForm);
//     console.log('Form submitted:', sanitizedForm);
//   };

//   useEffect(() => {
//     if (responce?.data && statusCode === 201) {
//       toast.success('Student registered successfully!');
//       setForm(initialForm);
//       setTimeout(() => {
//         navigate(uiRoutes.admin.student.list);
//       }, 1000);
//     }
//   }, [responce, statusCode, navigate]);

//   const filteredPrograms = programs.filter((p) => p.type === form.student_type);

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container card mt-4 p-4">
//           <h4 className="mb-3">Add Student</h4>
//           <form onSubmit={handleSubmit}>
//             {/* Row 1 */}
//             <div className="row mb-3">
//               <div className="col-md-6 mb-3">
//                 <label>First Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="first_name"
//                   value={form.first_name}
//                   onChange={handleChange}
//                 />
//                 <span className="val-message">{error?.data?.first_name}</span>
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label>Last Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="last_name"
//                   value={form.last_name}
//                   onChange={handleChange}
//                 />
//                 <span className="val-message">{error?.data?.last_name}</span>
//               </div>
//             </div>

//             {/* Row 2 */}
//             <div className="row mb-3">
//               <div className="col-md-6 mb-3">
//                 <label>Email</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   name="email"
//                   value={form.email}
//                   onChange={handleChange}
//                 />
//                 <span className="val-message">{error?.data?.email}</span>
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label>Mobile No</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="mobile_no"
//                   value={form.mobile_no}
//                   onChange={handleChange}
//                 />
//                 <span className="val-message">{error?.data?.mobile_no}</span>
//               </div>
//             </div>

//             {/* Row 3 */}
//             <div className="row mb-3">
//               <div className="col-md-6 mb-3">
//                 <label>Student Type</label>
//                 <select
//                   className="form-control"
//                   name="student_type"
//                   value={form.student_type}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select Type</option>
//                   <option value="kids">Kids</option>
//                   <option value="student">Student</option>
//                 </select>
//                 <span className="val-message">{error?.data?.student_type}</span>
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label>Program</label>
//                 <select
//                   className="form-control"
//                   name="program_id"
//                   value={form.program_id}
//                   onChange={handleChange}
//                   disabled={!form.student_type}
//                 >
//                   <option value="">Select Program</option>
//                   {filteredPrograms.map((prog) => (
//                     <option key={prog.id} value={prog.id}>
//                       {prog.name}
//                     </option>
//                   ))}
//                 </select>
//                 {form.program_id && (
//                   <div className="text-muted mt-1">
//                     Program Type: <strong>{filteredPrograms.find(p => String(p.id) === form.program_id)?.type}</strong>
//                   </div>
//                 )}
//                 <span className="val-message">{error?.data?.program_id}</span>
//               </div>
//             </div>

//             {/* Row 4 */}
//             <div className="row mb-3">
//               <div className="col-md-6 mb-3">
//                 <label>Fees</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   name="fees"
//                   value={form.fees}
//                   onChange={handleChange}
//                 />
//                 <span className="val-message">{error?.data?.fees}</span>
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label>Address</label>
//                 <textarea
//                   className="form-control"
//                   name="address"
//                   rows="2"
//                   value={form.address}
//                   onChange={handleChange}
//                 ></textarea>
//                 <span className="val-message">{error?.data?.address}</span>
//               </div>
//             </div>

//             <div className="text-end">
//               <button type="submit" className="btn btn-primary" >
//              Submit
//               </button>
//             </div>
//           </form>
//         </div>
//       }
//     />
//   );
// };

// export default AdminStudentAdd;

